import { Component, Input, OnInit } from '@angular/core';
import { SxInternalStateDesignerService } from 'app/private/sxfdesigner/services/internal-state-designer-service';
import { VEDependency, ViewEngine } from 'app/private/sxfdesigner/types/view-engine.interface';

@Component({
  selector: 'dependencies-view-engine-tap',
  templateUrl: './dependencies-view-engine.component.html'
})

export class DependenciesVEComponent implements OnInit {
  @Input() configuration;
  veDependencies = [];
  viewEngines: ViewEngine[] = [];
 
  constructor(public internalState: SxInternalStateDesignerService) {}

  ngOnInit(): void {
    this.viewEngines = this.internalState.getViewEngines()
    const configuration = this.configuration.find(attribute => attribute.name === 'configuration').value;
    if(configuration.veDependencies  && configuration.veDependencies.length > 0) {
      this.veDependencies = configuration.veDependencies;
      this.veDependencies.forEach(dep => {
        dep['libCode'] == null && (dep['libCode'] = dep['viewEngineCod']);
      });
    }
  }

  onChangeOption(viewEngineCod, index): void {
    viewEngineCod == '' && (viewEngineCod = this.veDependencies[index]['libCode']);
    const selectedVE = this.internalState.getViewEngines().find(ve => ve.codViewEngine === viewEngineCod);
    this.veDependencies[index] = <VEDependency> {
      libCode: this.veDependencies[index]['libCode'],
      viewEngineCod: selectedVE.codViewEngine,
      moduleName: selectedVE.moduleName,
      configuration: selectedVE.configuration
    }
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/modals/view-engine/tabs/dependencies/dependencies-view-engine.component.ts